import {
	Box,
	Button,
	Container,
	Grid,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Paper,
	Stack,
	Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import CheckIcon from '@mui/icons-material/Check';
import { PRICING_TIERS } from './constants';

const PricingSection = ({ id = 'pricing' }) => (
	<Box
		id={id}
		component="section"
		sx={{ py: { xs: 7, md: 10 }, scrollMarginTop: { xs: 72, md: 80 } }}
	>
		<Container maxWidth="lg">
			<Box sx={{ textAlign: 'center', mb: { xs: 3, md: 4 } }}>
				<Typography
					variant="overline"
					color="warning.main"
					sx={{ fontWeight: 700, letterSpacing: '0.14em' }}
				>
					Pricing
				</Typography>
				<Typography
					variant="h4"
					component="h2"
					sx={{ mt: 1, fontWeight: 700 }}
				>
					Simple pricing for small subs
				</Typography>
				<Typography
					variant="body1"
					color="text.secondary"
					sx={{ mt: 2, maxWidth: 640, mx: 'auto', lineHeight: 1.8 }}
				>
					Basic is the full product — proposals, automatic follow-ups, deposits,
					invoices, and payments — at $25/mo. Pro adds crew ops when you need
					them. Start with a 30-day free trial, no credit card.
				</Typography>
			</Box>

			<Grid
				container
				spacing={3}
				alignItems="stretch"
				justifyContent="center"
			>
				{PRICING_TIERS.map((tier) => (
					<Grid
						key={tier.id}
						size={{ xs: 12, md: 6 }}
						sx={{ maxWidth: { md: 480 } }}
					>
						<Paper
							elevation={tier.highlighted ? 4 : 0}
							sx={{
								p: 3,
								height: '100%',
								borderRadius: 3,
								border: '2px solid',
								borderColor: tier.highlighted ? 'warning.main' : 'divider',
								display: 'flex',
								flexDirection: 'column',
							}}
						>
							<Stack spacing={1} sx={{ mb: 3 }}>
								<Typography variant="h6" sx={{ fontWeight: 700 }}>
									{tier.name}
								</Typography>
								<Stack direction="row" alignItems="baseline" spacing={0.5}>
									<Typography variant="h3" sx={{ fontWeight: 800 }}>
										${tier.price}
									</Typography>
									<Typography variant="body2" color="text.secondary">
										/mo
									</Typography>
								</Stack>
								<Typography variant="body2" color="text.secondary">
									{tier.tagline}
								</Typography>
							</Stack>
							<List dense disablePadding sx={{ flexGrow: 1, mb: 3 }}>
								{tier.features.map((feature) => (
									<ListItem key={feature} disableGutters sx={{ py: 0.4 }}>
										<ListItemIcon sx={{ minWidth: 32 }}>
											<CheckIcon color="success" fontSize="small" />
										</ListItemIcon>
										<ListItemText
											primary={feature}
											slotProps={{
												primary: {
													variant: 'body2',
													color: 'text.primary',
												},
											}}
										/>
									</ListItem>
								))}
							</List>
							<Button
								component={Link}
								to="/signup"
								variant={tier.highlighted ? 'contained' : 'outlined'}
								color={tier.highlighted ? 'warning' : 'primary'}
								fullWidth
							>
								Start 30-day free trial
							</Button>
						</Paper>
					</Grid>
				))}
			</Grid>
		</Container>
	</Box>
);

export default PricingSection;
